//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'dayjs'
export default {
	data() {
		return {
			// orderType:''//1门票,2酒店,3美食,4特产,5线路
		}
	},
	props: {
		orderType: {
			type: [Number, String]
		},
		detail: {
			type: Object,
		},
		//线路
		useDate: {
			type: String
		},
		address: {
			type: String
		},
		//酒店
		checkInTime: {
			type: String
		},
		checkOutTime: {
			type: String
		}
	},
	computed: {
		payTypeName() {
			return '微信支付' // 暂时写死，都显示成微信支付
		},
	},
	methods: {
		handleClick(orderCode) {
			uni.navigateTo({
				url: `/pages/personalCenter/order/moreInfo?orderCode=${orderCode}`
			})
		},
	}
}
